// extracted by mini-css-extract-plugin
module.exports = {"container":"FileViewerZoom_container__2LD1h","control":"FileViewerZoom_control__3NvqF","disabled":"FileViewerZoom_disabled__3nvQi"};